/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreMewsCreateAliases {
  AUTOCOMPLETE_CONSCIOUSNESS_LEVEL = 'autocomplete-consciousness-level',
  CONTEXTUAL_BAR = 'contextual-bar',
  FETCH_CONSCIOUSNESS_LEVEL = 'fetch-consciousness-level',
  FIELD_CONSCIOUSNESS_LEVEL = 'field-consciousness-level',
  FIELD_HEART_RATE = 'field-heart-rate',
  FIELD_RESPIRATORY_RATE = 'field-respiratory-rate',
  FIELD_SETUP_DATE = 'field-setup-date',
  FIELD_SYSTOLIC_PA = 'field-systolic-pa',
  FIELD_TEMPERATURE = 'field-temperature',
  FORM_SCORE_MEWS_ADD = 'form-score-mews-add',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_HEART_RATE = 'input-heart-rate',
  INPUT_RESPIRATORY_RATE = 'input-respiratory-rate',
  INPUT_SETUP_DATE = 'input-setup-date',
  INPUT_SYSTOLIC_PA = 'input-systolic-pa',
  INPUT_TEMPERATURE = 'input-temperature',
  MAPPER_CONSCIOUSNESS_LEVEL = 'mapper-consciousness-level',
  PANEL_BODY = 'panel-body',
  PANEL_FORM = 'panel-form',
  PANEL_HEADER = 'panel-header',
  SCORE_MEWS_ADD_LAYOUT = 'score-mews-add-layout',
  TEXT_CONSCIOUSNESS_LEVEL = 'text-consciousness-level',
}
export { ScoreMewsCreateAliases };
